// @ts-check

/**
 * @type {GetNormalizerFunction}
 */
export const getNormalizer = ({ getId }) => (
  answersArray,
  stats,
  numVotes,
  localUserVote
) => {
  if (!Array.isArray(answersArray)) {
    return {}
  }

  numVotes += Number(!!localUserVote)

  // @ts-ignore yeah sure we have Object.values!
  return Object.values(
    answersArray.reduce((agg, item) => {
      const id = getId(item)
      const baseCount = (stats && stats[id]) || 0
      const voteCount = baseCount + Number(localUserVote === id)
      return {
        ...agg,
        [id]: {
          id: id,
          ...item,
          voteCount,
          voteValue:
            (voteCount && Math.round((voteCount / numVotes) * 100)) || 0,
        },
      }
    }, {})
  )
}

/**
 * @typedef {{
 *  [prop: string]: any
 * }} RawAnswer
 *
 * @typedef {{
 *  [key: string]: number
 * }} Stat
 *
 * @typedef {{
 *  id: any,
 *  voteCount: number,
 *  voteValue: number,
 *  [prop: string]: any
 * }} NormalizedAnswer
 *
 * @typedef {(
 *  answersArray: RawAnswer[],
 *  stats: Stat,
 *  numVotes: number,
 *  localUserVote: any
 *  ) => NormalizedAnswer[]} NormalizeFunction
 *
 * @typedef {{ getId: (item: any) => string|number }} GetNormalizerParams
 *
 * @typedef {(props: GetNormalizerParams) => NormalizeFunction} GetNormalizerFunction
 */
